import {
  GET_BENEFIT_PERIOD_BEGIN,
  GET_BENEFIT_PERIOD_SUCCESS,
  GET_BENEFIT_PERIOD_ERROR,
  GET_TOTAL_REWARDS_STATEMENT_BEGIN,
  GET_TOTAL_REWARDS_STATEMENT_SUCCESS,
  GET_TOTAL_REWARDS_STATEMENT_ERROR,
} from "./actions";

const initialState = {
  benefitPeriods: [],
  isBenefitPeriodsFetched: false,
  detail: {},
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_PERIOD_BEGIN:
      return { ...state, isBenefitPeriodsFetched: false };
    case GET_BENEFIT_PERIOD_ERROR:
      return { ...state, isBenefitPeriodsFetched: false, error: action.payload };
    case GET_BENEFIT_PERIOD_SUCCESS:
      return {
        ...state,
        isBenefitPeriodsFetched: true,
        benefitPeriods: action.payload,
      };
    case GET_TOTAL_REWARDS_STATEMENT_BEGIN:
      return { ...state };
    case GET_TOTAL_REWARDS_STATEMENT_ERROR:
      return { ...state, error: action.payload };
    case GET_TOTAL_REWARDS_STATEMENT_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      };
    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/reducer.js